import { dayKey, timesByDay } from './liveCalendar.ts';

/**
 * The calendar picker's days (components.md 6): the window's times by day,
 * past ones dropped (earlier today included), so a day with only past
 * times has none. A day has times when one of them can still be picked.
 */
export function pickerDays<T extends { id: string; startAt: string }>(
  days: string[], times: T[], timeZone: string, nowMs: number, disabledIds?: Set<string>,
): { byDay: Map<string, T[]>; hasTimes: (day: string) => boolean } {
  const keys = new Set(days);
  const nowIso = new Date(nowMs).toISOString();
  const byDay = timesByDay(times.filter((t) => t.startAt > nowIso && keys.has(dayKey(t.startAt, timeZone))), timeZone);
  const hasTimes = (day: string) => (byDay.get(day) ?? []).some((t) => !disabledIds?.has(t.id));
  return { byDay, hasTimes };
}

/** Today when it has times, else the first later day that has; today while the times load (components.md 6). */
export function openDay(days: string[], hasTimes: (day: string) => boolean, known: boolean): string {
  return (known ? days.find(hasTimes) : undefined) ?? days[0];
}
